import(/* webpackMode: "eager" */ "/app/src/app/[locale]/login/page.tsx");
